export const environment = {
  production: true,
  name: 'prod',
  languages: {
    availables: [
      'en-EN'
    ],
    default: 'en-EN'
  },
  aws: {
    amplify: {
      aws_user_pools_id: 'eu-west-1_cOvhAkj9S',
      aws_user_pools_web_client_id: '30l6j2df5bn9mis0mipllls5cm',
      API: {
        REST: 'https://carelflex-prod-iconfig-api.arkema.com/prod/'
      }
    },
    oauth: {
      domain: 'carelflex-prod-iconfig.auth.eu-west-1.amazoncognito.com',
      scope: ['aws.cognito.signin.user.admin', 'openid'],
      redirectSignIn: 'https://config-carelflex.arkemacloud.com/login',
      redirectSignOut: 'https://config-carelflex.arkemacloud.com/login',
      responseType: 'code'
    }
  }
};
